import styled from "styled-components";
export const ProgressBarBsStyle = styled.div`
  .progress {
    height: 5px;
    margin-bottom: 15px;
    .progress-bar {
      background-color: ${(props) => props.color};
      height: 5px;
    }
  }
`;
